/**
 * Centralized frontend configuration for API and asset URLs
 * 
 * This file centralizes all URL configuration for easy production deployment.
 * Update REACT_APP_API_URL in your .env file or build environment to point to your production API.
 * 
 * Development: http://localhost:5000/api
 * Production: https://api.yourdomain.com/api
 */

// Determine if we're in production
const isProduction = process.env.NODE_ENV === 'production';

// Base API URL for the backend
// Priority: REACT_APP_API_URL env variable > production default > development default
const getApiBaseUrl = () => {
  // If explicitly set in environment, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.endsWith('/api')
      ? process.env.REACT_APP_API_URL
      : `${process.env.REACT_APP_API_URL}/api`;
  }
  
  // Production default (Render.com web service)
  if (isProduction) {
    return 'https://farmers-network.onrender.com/api';
  }
  
  // Development default
  return 'http://localhost:5000/api';
};

export const API_BASE_URL = getApiBaseUrl();

// Origin (protocol + host) for serving images/static files from the backend
// Example: if API_BASE_URL is http://localhost:5000/api -> origin becomes http://localhost:5000
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '');

// Export configuration for debugging
export const CONFIG = {
  API_BASE_URL,
  API_ORIGIN,
  isProduction,
  nodeEnv: process.env.NODE_ENV || 'development',
};


